module.exports = __webpack_public_path__ + "media/colors/JASPEM2-1-af753917.png";